import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in">
      <div class="bg-white rounded-lg p-6 flex flex-col items-center shadow-xl animate-slide-up">
        <div class="spinner spinner-lg"></div>
        <p class="mt-4 text-gray-600">Chargement en cours...</p>
      </div>
    </div>
  `
})
export class LoaderComponent {}
